import type { MailboxInfo } from "owa-client-types";
import { getIsDataWorkerFaulted, getIsOfflineDataFaulted, getSessionId } from "owa-config";
import { getItem } from "owa-local-storage";
import { isMailboxSharedOrDelegate } from "owa-account-shared-mailbox-utils";
import { isOfflineSyncEnabled } from "./isOfflineSyncEnabled";
import type { PDVStateDetails } from "./isOfflinePeopleDataViaPDVEnabled";
import { getFallbackToNOPGALInSessionStorageKey, getFallbackToNOPGALLocalStorageKey, } from "./utils/toggleOfflineNoPGAL";

// Account eligibility shared by offline PDV and shadow PGAL sync, independent of their flights.
export function isOfflinePeopleDataEligibleForAccount(mailboxInfo: MailboxInfo, pdvStateDetails?: PDVStateDetails): boolean {
    const fallbackToNoPGAL = getItem(self, getFallbackToNOPGALLocalStorageKey(mailboxInfo));
    const isAccountFallbackToNoPGAL = !!fallbackToNoPGAL && fallbackToNoPGAL.toLocaleLowerCase() === "true";
    const fallbackToNoPGALSession = getItem(self, getFallbackToNOPGALInSessionStorageKey(mailboxInfo)) || "";
    const isSessionFallbackToNoPGAL = !!fallbackToNoPGALSession && getSessionId() === fallbackToNoPGALSession;
    const isOfflineSyncEnabledFlag = isOfflineSyncEnabled(mailboxInfo);
    const isDataWorkerFaulted = getIsDataWorkerFaulted();
    const isOfflineDataFaulted = getIsOfflineDataFaulted();
    const isMailboxSharedOrDelegateFlag = isMailboxSharedOrDelegate(mailboxInfo);
    
    if (pdvStateDetails) {
        pdvStateDetails.isOfflineSyncEnabled = isOfflineSyncEnabledFlag;
        pdvStateDetails.isAccountFallbackToNoPGAL = isAccountFallbackToNoPGAL;
        pdvStateDetails.isSessionFallbackToNoPGAL = isSessionFallbackToNoPGAL;
        pdvStateDetails.isDataWorkerFaulted = isDataWorkerFaulted;
        pdvStateDetails.isOfflineDataFaulted = isOfflineDataFaulted;
        pdvStateDetails.isMailboxSharedOrDelegate = isMailboxSharedOrDelegateFlag;
    }
    
    return (isOfflineSyncEnabledFlag &&
        !isAccountFallbackToNoPGAL &&
        !isSessionFallbackToNoPGAL &&
        !isDataWorkerFaulted &&
        !isOfflineDataFaulted &&
        !isMailboxSharedOrDelegateFlag);
}
